@import '../../../globals/main.scss';

@import './pn-marketweb-siteheader-common.scss';

pn-marketweb-siteheader-login-profileselection {
}

.pn-marketweb-siteheader-login-profileselection-heading {
  display: block;
  padding: 0.5rem 0 1rem;
}

.pn-marketweb-siteheader-login-profileselection-user,
.pn-marketweb-siteheader-login-profileselection-currentprofile {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.pn-marketweb-siteheader-login-profileselection-user-name,
.pn-marketweb-siteheader-login-profileselection-currentprofile-name {
  line-height: 1;
}

.pn-marketweb-siteheader-login-profileselection-user-description,
.pn-marketweb-siteheader-login-profileselection-currentprofile-description {
  font-weight: 400;
  white-space: normal;
  word-break: break-all;
  color: $gray700;
  font-size: 0.75em;
}

.pn-marketweb-siteheader-login-profileselection-divider {
  height: 1rem;
  width: 100%;
  background: $blue400;
  position: relative;

  margin-left: -1em; // Negative positioning due to nav dropdown's padding
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  border-radius: 0 0.6em 0.6em 0;
  padding: 0;
  &::after {
    content: '';
    width: 0.6em;
    height: 0.6em;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
    background: inherit;
    transform: translateX(calc(100% + 0.2em));
  }
}

.pn-marketweb-siteheader-login-profileselection-profileoption {
}

.pn-marketweb-siteheader-login-profileselection-profileoption-link {
  display: flex;
  background: $white;
  transition: background 0.15s ease-in-out;
  // width:100%;
  margin: 0 -1em; // Negative margin due to dropdown content padding
  padding: 0.6rem 1.6rem;
  text-decoration: none;
  color: $blue700;
  align-items: center;
  &:hover,
  &:focus,
  &:active {
    background: $gray50;
  }
}

.pn-marketweb-siteheader-login-profileselection-profileoption-content {
  flex-grow: 1;
}
.pn-marketweb-siteheader-login-profileselection-profileoption-name {
  font-weight: 700;
}

.pn-marketweb-siteheader-login-profileselection-profileoption-description {
  font-weight: 400;
  white-space: normal;
  word-break: break-all;
  color: $gray700;
  font-size: 0.75em;
}

.pn-marketweb-siteheader-login-profileselection-logout {
  padding: 1.6rem;
  text-align: center;
  width: 100%;
}

.pn-marketweb-siteheader-login-profileselection-logout-link {
  display: inline-block;
  font-weight: 500;
  color: $blue700;
  text-decoration: none;
  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
  }
}
